import { useMediaQuery } from "@mantine/hooks";

const useDevice = () => {
  const isMobile = useMediaQuery(
    "screen and (min-width: 1px) and (max-width: 513px)"
  );
  const isTablet = useMediaQuery(
    "screen and (min-width: 514px) and (max-width: 1023px)"
  );

  return {
    isMobile,
    isTablet,
    isDesktop: !isMobile && !isTablet,
    device: isMobile ? "mobile" : isTablet ? "tablet" : "desktop",
  };
};

export default useDevice;
